import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft,faChevronRight,faPencilAlt,faPlusSquare,faTrashAlt,faTimes } from '@fortawesome/free-solid-svg-icons'

library.add(
    faChevronLeft,
    faChevronRight,
    faPencilAlt,
    faPlusSquare,
    faTrashAlt,
    faTimes
);
